import { Navigate, useParams } from "react-router-dom";
import PropertySetupWizard from "../PropertySetupWizard";
import { useAuth } from "../routing/AuthContext";
import { ROUTES } from "../routing/paths";

export default function SetupNewPage() {
  const { session } = useAuth();

  return <PropertySetupWizard mode="new" authSession={session} />;
}

export function SetupEditPage() {
  const { documentId } = useParams<{ documentId: string }>();
  const { session, getPropertyByDocumentId } = useAuth();
  const property = documentId ? getPropertyByDocumentId(documentId) : null;

  if (!documentId || !property) {
    return <Navigate to={ROUTES.selectProperty} replace />;
  }

  return (
    <PropertySetupWizard
      mode="edit"
      authSession={session}
      editProperty={property}
      documentId={documentId}
    />
  );
}
